import { Undo2 } from "lucide-react";
import { useState } from "react";

import { CarregandoTabela } from "@/components/carregando";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

import { producaoApi } from "../api";
import { fmtBRL, fmtData, fmtQtd } from "../lib/formato";

/** Historico de producoes com estorno (popup de confirmacao). */
export default function HistoricoProducao({ itens, carregando = false, canEdit, onEstornado, toast }) {
  const [alvo, setAlvo] = useState(null);
  const estornar = async () => {
    try { await producaoApi.estornar(alvo.id); toast.success(`Produção de ${alvo.nome} estornada.`); onEstornado(); }
    catch (e) { toast.error(e.message); }
    finally { setAlvo(null); }
  };
  return (
    <div className="bg-card rounded-xl border shadow-sm overflow-hidden" data-e2e="historico-producao">
      <div className="px-4 py-3 border-b bg-muted/20"><h3 className="font-semibold">Histórico de produção</h3></div>
      {carregando ? <CarregandoTabela linhas={3} colunas={7} className="" /> : !itens.length ? <p className="p-6 text-sm text-muted-foreground text-center">Nenhuma produção registrada ainda.</p> : (
        <div className="overflow-x-auto"><table className="w-full text-sm">
          <thead className="bg-muted/50 border-b"><tr>
            {["Quando", "Receita", "Lotes", "Produzido", "Custo", "Por", ""].map((h) => <th key={h} className="text-left py-2.5 px-4 text-[11px] font-semibold text-muted-foreground uppercase tracking-wider">{h}</th>)}
          </tr></thead>
          <tbody>{itens.map((p) => (
            <tr key={p.id} className={`border-b ${p.estornada ? "opacity-50 line-through" : ""}`} data-e2e="linha-producao">
              <td className="py-2.5 px-4 whitespace-nowrap tabular-nums">{fmtData(p.created_at)}</td>
              <td className="py-2.5 px-4 font-medium">{p.nome}{p.observacao ? <span className="block text-[11px] text-muted-foreground font-normal">{p.observacao}</span> : null}</td>
              <td className="py-2.5 px-4 tabular-nums">{fmtQtd(p.lotes, "")}</td>
              <td className="py-2.5 px-4 tabular-nums">{fmtQtd(p.quantidade, p.unidade)} {p.unidade}</td>
              <td className="py-2.5 px-4 tabular-nums">{fmtBRL(p.custo_total)}</td>
              <td className="py-2.5 px-4 text-muted-foreground">{p.username || "—"}</td>
              <td className="py-2.5 px-4 text-right">
                {canEdit && !p.estornada && (
                  <button type="button" onClick={() => setAlvo(p)} data-testid={`estornar-producao-${p.id}`}
                    className="inline-flex items-center gap-1 h-8 px-2.5 rounded-md border text-xs hover:border-destructive hover:text-destructive transition-colors"><Undo2 className="w-3.5 h-3.5" /> estornar</button>
                )}
                {p.estornada ? <span className="text-[11px] text-muted-foreground">estornada</span> : null}
              </td>
            </tr>))}</tbody>
        </table></div>
      )}
      <AlertDialog open={!!alvo} onOpenChange={(o) => { if (!o) setAlvo(null); }}>
        <AlertDialogContent data-e2e="dialog-estornar">
          <AlertDialogHeader>
            <AlertDialogTitle>Estornar esta produção?</AlertDialogTitle>
            <AlertDialogDescription>
              {alvo ? <>Os ingredientes base de <strong>{alvo.nome}</strong> ({fmtQtd(alvo.lotes, "")} lote{Number(alvo.lotes) === 1 ? "" : "s"}) voltam ao estoque e {fmtQtd(alvo.quantidade, alvo.unidade)} {alvo.unidade} do item pronto saem. As movimentações inversas ficam registradas.</> : null}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={estornar} data-e2e="confirmar-estorno" className="bg-destructive text-destructive-foreground hover:bg-destructive/90">Estornar</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
